export default __webpack_public_path__ + "static/media/Dr. Prabu Selvam.4ba0b724.png";